// extracted by mini-css-extract-plugin
export default {"overlay":"Join_overlay__DMT44","content":"Join_content__fBads","buttons":"Join_buttons__q5R8u","background":"Join_background__yEnW9","video":"Join_video__OAccY"};